module.exports = __webpack_public_path__ + "img/search.3b82ba6f.svg";